















import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { isHex, hexToString, hexToBn, hexToNumber } from '@polkadot/util';
import { Unit } from '../types';

@Component
export default class Balance extends Vue {

  set arg(value: number) {
    this.value = value;
    this.handleSelected();
  }

  get arg() {    
    const defaultValue = this.defaultValue && isHex(this.defaultValue)
     ? hexToBn(this.defaultValue as string).toString()
     : this.defaultValue;

    if (defaultValue !== null && typeof defaultValue === 'object') {
      return defaultValue.toString()
    }
    
    return defaultValue || this.value;
  }

  get chainProps() {
    return this.chainProperties;
  }

  get units() { 
    return [
      { name: 'femto', value: 1e-12*this.getChainDecimalsMultiplier()},
      { name: 'pico', value: 1e-9*this.getChainDecimalsMultiplier()},
      { name: 'nano', value: 1e-6*this.getChainDecimalsMultiplier()},
      { name: 'micro', value: 1e-3*this.getChainDecimalsMultiplier()},
      { name: 'mili', value: 1*this.getChainDecimalsMultiplier()},
      { name: this.getTokenSymbol(), value: 1e3*this.getChainDecimalsMultiplier()},
      { name: 'Kilo', value: 1e6 * this.getChainDecimalsMultiplier()},
      { name: 'Mega', value: 1e9 * this.getChainDecimalsMultiplier()},
      { name: 'Giga', value: 1e12 * this.getChainDecimalsMultiplier()},
      { name: 'Tera', value: 1e15 * this.getChainDecimalsMultiplier()},
      { name: 'Peta', value: 1e18 * this.getChainDecimalsMultiplier()},
      { name: 'Exa', value: 1e21 * this.getChainDecimalsMultiplier()},
      { name: 'Zeta', value: 1e24 * this.getChainDecimalsMultiplier()},
      { name: 'Yotta', value: 1e27 * this.getChainDecimalsMultiplier()},
    ];
  }

  @Prop() public argument!: any;
  @Prop({ default: false }) public readonly disabled!: boolean;
  @Prop({ default: null }) public readonly defaultValue!: any;
  

  private chainProperties: any = '-';
  private value = 0;
  private unitsSelected: number = 1e3*this.getChainDecimalsMultiplier();
  
  private getTokenSymbol(): string {
    this.chainProperties = this.$store.state.chainProperties;
    if (this.chainProperties !== '-') {
      return this.chainProperties.tokenSymbol;
    }
    return '-';
  }

  private getChainDecimalsMultiplier(): number {
    return 1*10**this.$store.state.chainProperties.tokenDecimals 
  } 

  @Watch('unitsSelected')
  private function() {
    this.handleSelected();
  }

  @Emit('selected')
  private handleSelected() {
    return { [this.argument.name.toString()]: this.arg * this.unitsSelected };
  }
}
